import { AvatarOrganisationComponent } from './avatar-organisation.component';

export default angular
  .module('sfMobile.components.avatar-organisation', [
    'sfMobile.constants.image-sizes',
    'sfMobile.services.files',
    'sfMobile.components.avatar',
  ])
  .component('sfAvatarOrganisation', AvatarOrganisationComponent).name;
